import type { GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult } from "./types";

export function isGetAppsAppGroupIdUserImportsImportIdScanEventNamesResult(
  value: unknown
): value is GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const object = value as Record<string, unknown>;
  if (typeof object.event_properties_by_name !== "object" || object.event_properties_by_name === null) {
    return false;
  }

  const eventPropertiesByName = object.event_properties_by_name as Record<string, unknown>;
  return Object.values(eventPropertiesByName).every(
    (properties) => Array.isArray(properties) && properties.every((property) => typeof property === "string")
  );
}
